/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
	<footer class="footer-wrap">
		<div class="content">
			<div>
				<h3>{{$t('menu.job')}}</h3>
				<a @click="handleJob">{{$t('media.reJob')}}</a>
				<!-- <a href="https://www.hotjob.cn/wt/BCSC/web/index/social" target="_blank">{{$t('media.reJob')}}</a>
				<a href="https://www.hotjob.cn/wt/BCSC/web/index/campus" target="_blank">{{$t('media.CJob')}}</a>
				<a href="https://www.hotjob.cn/wt/BCSC/web/index/interns" target="_blank">{{$t('media.InternJob')}}</a> -->
			</div>
			<div>
				<h3>{{$t('contact.contact')}}</h3>
				<a @click="change(1)">{{$t('fromData.contact')}}</a>
				<a @click="change(2)">{{$t('media.mediaInvestor')}}</a>
			</div>
			<div>
				<h3>{{$t('media.contactWay')}}</h3>
				<p>{{$t('footer.tel')}}</p>
				<p>{{$t('footer.fax')}}</p>
				<p>{{$t('footer.email')}}</p>
				<p class="address" :class="lang == 'en' ? 'address-en' : ''">{{$t('footer.address')}}</p>
				<p>{{$t('footer.code')}}</p>
			</div>
			<div>
				<!-- <div style="text-align: center;"> -->
					<!-- <a href="https://www.clinicalservice.cn/home" target="_blank" style="display: inline-block;width: 100%;text-align: center;">{{$t('footer.szName')}}</a> -->
				<!-- </div> -->
				<!--<img src="../assets/foot_code_1.png" alt="">-->
				<!-- <img src="../assets/meta_lg.png" alt /> -->
        <img src="../assets/foot_code_1.jpg" alt="" @click="goClinical" style="cursor: pointer;" />
				<img src="../assets/foot_code_2.png" alt />
				<!--<img src="../assets/foot_code_3.png" alt="">-->
			</div>
		</div>
		<div class="company">
			<p>
				{{$t('footer.company')}} <br />
        <!-- <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502047871"
          style="color: #fff"
          ><img src="../assets/national_emblem.png" style="vertical-align: sub;" /> 京公网安备
          11010502047871号</a
        >
        &nbsp; -->
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #fff"
          >{{ $t("footer.compangCode") }}</a
        >
			</p>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'kllk-footer-nav',
	methods: {
		goClinical() {
			window.open('https://www.clinicalservice.cn/home', '_blank');
		},
		handleJob() {
			this.$router.push({ name: 'COMPANYS' })
		},
		change(index) {
			switch (index) {
				case 1:
					this.$router.push({
						name: 'COMPANYS',
						query: {
							type: 1
						}
					});
					break
				case 2:
					this.$router.push({
						name: 'MEDIA',
					})
					break
			}
		},
	},
	computed: {
		lang() {
			return sessionStorage.getItem('language')
		},
	},
}
</script>

<style lang="less" scoped>
@import "../style/constant";

.footer-wrap {
	background-color: #3a4e64;
	color: white;
	padding: 40px;

	.content {
		max-width: @page-width;
		margin: 0 auto;
		display: flex;

		.address-en {
			width: 500px;
			white-space: normal;
		}

		div {
			h3:first-child {
				margin-bottom: 27px;
			}

			a {
				display: block;
				text-decoration-line: none;
			}

			p,
			a {
				color: #bdc1c5;
				padding-bottom: 18px;
				font-size: 14px;
				cursor: pointer;
				white-space: nowrap;
			}
		}

		div:not(:last-child) {
			width: calc(50% / 3);
		}

		div:last-child {
			width: 50%;
			// display: flex;
			flex-direction: column;
			align-items: flex-end;
			margin-left: 50px;
			text-align: right;

			// img:first-child {
			// 	width: 300px;
			// 	height: 70px;
			// 	object-fit: contain;
			// }

			// img:nth-child(2) {
			// 	width: 140px;
			// 	height: 140px;
			// 	object-fit: cover;
			// 	margin-right: 68px;
			// }

			img {
				width: 140px;
				height: 140px;
				object-fit: cover;
				margin-right: 68px;
			}
		}
		@media screen and (min-width: 320px) and (max-width: 480px) {
			div:last-child {
				width: 100%;
				align-items: center;
				img:last-child {
					margin-right: 0px;
				}
			}
		}
	}

	.company {
		max-width: @page-width;
		margin: 50px auto 0;
		padding-top: 50px;
		border-top: 1px solid #67727d;
		text-align: center;

		p {
			color: #bdc1c5;
		}
    }
    @media screen and (min-width: 320px) and (max-width: 480px) {
        .company {
            margin: 30px auto 0;
            padding-top: 20px;
            p {
                font-size: 12px;
            }
        }
    }

	@media screen and (min-width: 320px) and (max-width: 480px) {
		.content {
			width: 100%;
			display: inline-block !important;
			div {
				h3:first-child {
					margin-bottom: 20px;
				}
			}
			div:not(:last-child) {
				width: 100%;
			}
			div {
				p,
				a {
					white-space: initial;
					font-size: 12px;
				}
			}
		}
	}
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.footer-wrap {
		padding: 17px;
	}
}
</style>
